import axios from "axios";

export const fetchUserByAddress = async (address) => {
  try {
    const response = await axios.get(
      `https://chainpulseserver.onrender.com/api/user/${address}`,
      {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
      }
    );

    const userData = response.data;

    return userData; // Return the entire data

    // If you want to filter the user by address here, you can do it like this:
    // const foundUser = userData.find((user) => user.solAddress === address);
    // return foundUser;
  } catch (error) {
    console.error("Error:", error);
  }
};
